import FitOption from '@components/ui/FitOption'
import styles from './styles.module.scss'
import { ChildFilterValue } from '../../types'

export type RectangleOptionsProps = {
  values: ChildFilterValue[]
  onSelect: (option: string) => void
  classes?: string
}

function RectangleOptions({
  onSelect,
  values,
  classes = ''
}: RectangleOptionsProps) {
  return (
    <div className={`${styles.RectangleOptions} ${classes}`}>
      {values.map(option => (
        <FitOption
          key={option.value}
          selected={option.selected}
          label={option.title}
          optionValue={option.value}
          active={option.active}
          onSelect={onSelect}
        />
      ))}
    </div>
  )
}

export default RectangleOptions
